import { effect, Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { BinderService } from '../api/binder.service';

@Injectable({
  providedIn: 'root'
})
export class ExcemptionStatusService {
  private pending = new BehaviorSubject<boolean | null>(null);
  pending$ = this.pending.asObservable();
  private excempt = new BehaviorSubject<boolean | null>(null);
  excempt$ = this.excempt.asObservable();
  private reason = new BehaviorSubject<string | null>(null);
  reason$ = this.reason.asObservable();

  binderModelSubscription!: Subscription;

  constructor(private binderModelService: BinderService) {
    effect(() => {
      const binder = this.binderModelService.currentBinder()
      if(binder) {
        this.setStatus(binder.contractEx, binder.exPending, binder.exemptionReasons?.[0]?.reason || null);
      }
    });
   }

  getExemptionStatus(ex:boolean | null, pending:boolean | null, reason:string | null) {
    if (pending) {
      return 'Exemption Pending';
    }
    if (ex !== null) {
      return ex ? 'Exempt' : 'Exemption Denied';
    }
    return 'Unknown';
  }

  setStatus(ex:boolean | null, pending:boolean | null, reason:string | null) {
    this.excempt.next(ex);
    this.pending.next(pending);
    this.reason.next(reason);
  }
}
